import { ISelectedCoursesState } from '@/src/types'
import { createDraftSafeSelector } from '@reduxjs/toolkit'

const selectCourses = (state) => state.selectedCourses

const selectedCoursesSelector = createDraftSafeSelector(
  selectCourses,
  (selectedCoursesState: ISelectedCoursesState) => selectedCoursesState,
)

export default selectedCoursesSelector
